module.exports = ".tabs-left.filters span {\n  white-space: nowrap; }\n\n.tabs-left.filters li {\n  padding-left: 3px;\n  font-weight: bold;\n  text-transform: uppercase;\n  text-align: left; }\n\n.filterItem {\n  overflow: hidden;\n  list-style-type: disc;\n  padding-left: 3px;\n  margin: 0px;\n  text-transform: none;\n  font-size: small;\n  font-weight: normal; }\n\n.filterItem:hover {\n  overflow: visible;\n  cursor: e-resize;\n  padding-left: 0;\n  opacity: 0.35;\n  text-align: right;\n  font-style: oblique; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app-filter-tabs/app-filter-tabs.component.scss
// module id = 1167
// module chunks = 1